import style from './AvailableAmount.css';
import FormatterUtils from '../../../utils/formatter.utils';
import useTranslation from '../../../localization/i18n.context';
import Button from '../../shared/Button/Button';
import { _className } from '../../../utils/classname.utils';
import NavigationUtils from '../../../utils/navigation.utils';
import { EnterAmountType } from '../../../routes/EnterAmountPage/EnterAmountProvider';

export default function AvailableAmount({
  className = '',
  cardFrom,
  amount,
  availableAmounts,
  type,
}) {
  const { t, getCurrency } = useTranslation();

  function onButtonClick() {
    return NavigationUtils.navigate(NavigationUtils.Routes.TOPUP, false, {
      organization: cardFrom.organizationCode,
    });
  }

  const amountCondition = () => {
    return Number(amount) > Number(cardFrom.balance);
  };

  return (
    <div className={`${className} ${style.container}`}>
      <div
        className={`${style.content} ${_className(
          amountCondition(),
          style['content--insufficient'],
        )}`}
      >
        <p className={style.text}>
          {t('{available} available').replace(
            '{available}',
            FormatterUtils.currency(
              cardFrom.balance,
              getCurrency(cardFrom.currency),
            ),
          )}
        </p>
      </div>
      {amountCondition() && type !== EnterAmountType.MICROLOAN && (
        <Button
          className={style.button}
          type={Button.Type.TERTIARY}
          size={Button.Size.SMALL}
          onClick={onButtonClick}
        >
          {t('Add funds')}
        </Button>
      )}
    </div>
  );
}
